<template>
    <div class="employee">
        <div class="tableConBox">
            <div class="tableTem">
                <div class="HSpace1"></div>
                <div class="searchBox flex flex-align-center">
                    <div class="searchCon clearfix">
                        <div class="left types" style="display:flex;align-items:center;width:500px">
                            <span style="display:inline-block;width:80px">员工状态:</span>
                             <el-radio-group style="width:130px" v-model="employeeStatus">
                                <el-radio :label="true">启用</el-radio>
                                <el-radio :label="false">禁用</el-radio>
                            </el-radio-group>
                            
                            <span>
                                <el-input v-model="searchVal" style="width:230px;margin-left:10px;" placeholder="请输入姓名或手机号进行搜索..."></el-input>
                            </span>
                            <!-- <el-select v-model="employeeStatus">
                                <el-option
                                  v-for="item in [{value: 'ON',label: '启用'},{value: 'OFF',label: '禁用'}]"
                                  :key="item.value"
                                  :label="item.label"
                                  :value="item.value">
                                </el-option>
                            </el-select> -->
                        </div>
                        <!-- <div class="left searchBtn" style="width:120px;margin-left:20px;">
                            <button type="button" @click="shopmanShow" ><i class="el-icon-plus"></i>老板收款码</button>
                        </div>
                        <div class="left searchBtn" style="margin-left:10px;">
                            <button type="button" @click="codeBtn = true;code=''">获取验证码</button>
                        </div> -->
                        <div class="right searchBtn">
                            <button type="button" @click="clear"><i class="el-icon-plus"></i>添加员工</button>
                        </div>
                        <div class="right tip flex flex-align-center">
                            <i class="iconfont icon-caution"></i>
                            <span>员工默认密码为：123456，请尽快修改</span>
                        </div>
                    </div>
                </div>
                <div class="HSpace2">&nbsp;</div>
                <div class="tableBox">
                    <div class="tableBoxScroll">
                        <table class="titleTable">
                            <tr>
                                <th style="width:8%">工号</th>
                                <th style="width:11%">姓名</th>
                                <th style="width:13%">电话</th>
                                <th style="width:11%">岗位</th>
                                <th style="width:11%">销售目标(元)</th>
                                <!-- <th style="width:12%">微信收款码</th> -->
                                <!-- <th style="width:12%">支付宝收款码</th> -->
                                <th style="width:11%">状态</th>
                                <th style="width:11%">操作</th>
                            </tr>
                        </table>
                        <div class="scrollBox">
                            <div class="scroll">
                                <table class="conTable" :class="{overLengthTable:employeeList.length>pageSize}">
                                    <tr v-for="item in employeeList" class="listTr">
                                        <td style="width:8%">{{item.code}}</td>
                                        <td style="width:11%">{{item.name}}</td>
                                        <td style="width:13%">{{item.mobile}}</td>
                                        <td style="width:11%">{{item.groupName}}</td>
                                        <td style="width:11%">{{item.target}}</td>
                                        <!-- <td style="width:12%">
                                           <span v-if="item.id" v-text="item.wechatPayUrl?'已设置':'未设置'" :style="{color:(item.wechatPayUrl?'#51BE7E':'#E06C6C')}"></span>
                                        </td> -->
                                        <!-- <td style="width:12%">
                                            <span v-if="item.id" v-text="item.aliPayUrl?'已设置':'未设置'" :style="{color:(item.aliPayUrl?'#51BE7E':'#E06C6C')}"></span>
                                        </td> -->
                                        <td style="width:11%"><span v-if="item.id" class="enabled" :class="{fal:!item.enabled}">{{item.enabled?'启用':'禁用'}}</span></td>
                                        <td style="width:11%">
                                            <div v-if="item.id" class="btnInline">
                                                <span :title="item.enabled?'点击禁用':'点击启用'" @click="enabledEmployee(item)" class="enabled-btn">{{item.enabled?'禁用':'启用'}}</span>
                                                <!-- <el-switch
                                                :title="item.enabled?'点击禁用':'点击启用'"
                                                @change="enabledEmployee(item)"
                                                v-model="item.enabled"
                                                on-text=""
                                                off-text=""
                                                on-color="#51BE7E"
                                                off-color="#E06C6C">
                                                </el-switch> -->
                                                <span title="修改" @click="getCurEmployee(item)"><i class="iconfont icon-bianji"></i></span>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 添加店主首款码 -->
        <el-dialog
            :title="'添加老板收款码'"
            :visible.sync="shopmanBtn"
            v-loading.body="infoload"
            size="tiny">
            <div>
                <div class="msgBox clearfix">
                    <div class="left img_box clearfix" style="margin:30px 0;">
                        
                        <span class="left itemName"><i>*</i>收款码</span>
                        <div class="left img">
                            <div class="img_item left">
                                <img v-if="shopman.wechatPayUrl" :src="shopman.wechatPayUrl" alt="">
                                <span v-if="shopman.wechatPayUrl" @click="delImg('bossWechat')" class="del-img">X</span>
                            </div>
                            <div class="img_up_btn left">
                                <i class="iconfont icon-xiazai"></i>
                                <input type="file" accept=".png,.jpg,.jpeg" @change="coverImg($event,'shopmanWechatPayUrl')" class="pcImgFile" title="选择图片">
                                <input type="file" accept="image/*" @change="coverImg($event,'shopmanWechatPayUrl')" class="mobileImgFile">
                            </div>
                           <div class="left" style="width:100%;text-indent:35%;margin-top:10px;">
                                微信
                            </div>
                        </div>
                        <div class="clear"></div>
                        <div class="left img img_mobile">
                            <div class="img_item left">
                                <img v-if="shopman.aliPayUrl" :src="shopman.aliPayUrl" alt="">
                                <span v-if="shopman.aliPayUrl" @click="delImg('bossAli')" class="del-img">X</span>
                            </div>
                            <div class="img_up_btn left">
                                <i class="iconfont icon-xiazai"></i>
                                <input type="file" accept=".png,.jpg,.jpeg" @change="coverImg($event,'shopmanAliPayUrl')" class="pcImgFile" title="选择图片">
                                <input type="file" accept="image/*" @change="coverImg($event,'shopmanAliPayUrl')" class="mobileImgFile">
                            </div>
                            <div class="clear"></div>
                            <div class="left" style="width:100%;text-indent:30%;margin-top:10px;">
                                支付宝
                            </div>
                        </div>
                    </div>
                </div>
                <div class="short_message" v-if="payUrlBtn">
                    <div class="disclaimer">
                        <el-checkbox v-model="disclaimer">我已经详细阅读并同意</el-checkbox><span style="color:#20a0ff;margin-left:5px; ">火星捕手使用许可及服务协议</span>
                    </div>
                </div> 
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="shopmanBtn=false" class="cancel">取消</button>
                <button type="button" @click="shopmanFn" class="save" v-if="disclaimer">保存</button>
                <button type="button" class="cancel" style="margin-rignt:0px;" v-else>保存</button>
            </span>
        </el-dialog>
         <!-- 修改员工 -->
        <el-dialog
            :title="isEdter?'修改员工':'添加员工'"
            :visible.sync="addEmplVisible"
            v-loading.body="infoload"
            size="tiny">
            <div>
                <div class="msgBox clearfix">
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>工号</span>
                        <input type="text" class="left itemInput" v-model="newEmployee.code" placeholder="请输入员工工号">
                    </div>
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>姓名</span>
                        <input type="text" class="left itemInput" v-model="newEmployee.name" placeholder="请输入员工姓名">
                    </div>
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>电话</span>
                        <input type="text" class="left itemInput" v-model="newEmployee.mobile" placeholder="请输入员工电话" :style="{display:(!isEdter?'block':'none')}">
                        <input type="text" class="left itemInput" v-model="newEmployee.mobile" placeholder="请输入员工电话" readonly=""  :style="{display:(isEdter?'block':'none'),'border-color':(isEdter?'#fff':'#fff')}">
                    </div>
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>岗位</span>
                        <el-select placeholder="请选择员工岗位" v-model="newEmployee.groupId" class="itemSelect">
                            <el-option
                                v-for="item in jobsList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="left msgItem clearfix">
                        <span class="left itemName" style="width:45%;"><i>*</i>发放优惠券</span>
                        <el-radio class="radio left itemRadio" v-model="newEmployee.sendCouponEnabled" :label="1">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="newEmployee.sendCouponEnabled" :label="0">否</el-radio>
                    </div>
                    <!--  -->
                    <div class="left msgItem clearfix" v-if="deliveryEnabled">
                        <span class="left itemName" style="width:45%;">是否允许配送</span>
                        <el-radio class="radio left itemRadio" v-model="newEmployee.deliveryEnabled" :label="true">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="newEmployee.deliveryEnabled" :label="false">否</el-radio>
                    </div>
                    <!--  -->
                    <!-- <div class="left msgItem clearfix" v-if="leaseProductEnabled">
                        <span class="left itemName" style="width:45%;">外设归还</span>
                        <el-radio class="radio left itemRadio" v-model="newEmployee.leaseEnabled" :label="true">是</el-radio>
                        <el-radio class="radio left itemRadio"  v-model="newEmployee.leaseEnabled" :label="false">否</el-radio>
                    </div> -->
                    <!--  -->
                    <div class="left msgItem clearfix">
                        <span class="left itemName"><i>*</i>销售目标</span>
                        <input type="text" class="left itemInput" v-model="newEmployee.target" placeholder="请输入员工销售目标">
                    </div>
                    <div class="left img_box clearfix">
                        <span class="left itemName"><i>*</i>员工头像</span>
                        <div class="left img">
                            <div class="img_item left">
                                <img v-if="newEmployee.photo" :src="newEmployee.photo" alt="">
                                <!-- <span v-if="newEmployee.photo" @click="delImg('avatar')" class="del-img">X</span>s -->
                            </div>
                            <div class="img_up_btn left">
                                <i class="iconfont icon-xiazai"></i>
                                <input type="file" accept=".png,.jpg,.jpeg" @change="coverImg($event,'avatar')" class="pcImgFile" title="选择图片">
                                <input type="file" accept="image/*" @change="coverImg($event,'avatar')" class="mobileImgFile">
                            </div>
                           <div class="left" style="width:100%;text-indent:35%;margin-top:10px;">
                                员工头像
                           </div>
                        </div>
                        <!-- <span class="left itemName"><i>*</i>收款码</span>
                        <div class="left img">
                            <div class="img_item left">
                                <img v-if="newEmployee.wechatPayUrl" :src="newEmployee.wechatPayUrl" alt="">

                                <span v-if="newEmployee.wechatPayUrl" @click="delImg('wechat')" class="del-img">X</span>

                            </div>
                            <div class="img_up_btn left">
                                <i class="iconfont icon-xiazai"></i>
                                <input type="file" accept=".png,.jpg,.jpeg" @change="coverImg($event,'wechatPayUrl')" class="pcImgFile" title="选择图片">
                                <input type="file" accept="image/*" @change="coverImg($event,'wechatPayUrl')" class="mobileImgFile">
                            </div>
                           <div class="left" style="width:100%;text-indent:35%;margin-top:10px;">
                                微信
                            </div>
                        </div>
                        <div class="clear"></div>
                        <div class="left img img_mobile">
                            <div class="img_item left">
                                <img v-if="newEmployee.aliPayUrl" :src="newEmployee.aliPayUrl" alt="">

                                <span v-if="newEmployee.aliPayUrl" @click="delImg('ali')" class="del-img">X</span>

                            </div>
                            <div class="img_up_btn left">
                                <i class="iconfont icon-xiazai"></i>
                                <input type="file" accept=".png,.jpg,.jpeg" @change="coverImg($event,'aliPayUrl')" class="pcImgFile" title="选择图片">
                                <input type="file" accept="image/*" @change="coverImg($event,'aliPayUrl')" class="mobileImgFile">
                            </div>
                            <div class="clear"></div>
                            <div class="left" style="width:100%;text-indent:30%;margin-top:10px;">
                                支付宝
                            </div>
                        </div> -->
                    </div>
                </div>      
                <div class="short_message" v-if="isEdter&&payUrlBtn">
                    <div class="disclaimer">
                        <el-checkbox v-model="disclaimer">我已经详细阅读并同意</el-checkbox><span style="color:#20a0ff;margin-left:5px; ">火星捕手使用许可及服务协议</span>
                    </div>
                </div>         
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="addEmplVisible=false" class="cancel" id="employeeCancel">取消</button>
                <button type="button" @click="addEmployee" class="save" v-if="disclaimer" id="employeeSave">保存</button>
                <button type="button" class="cancel" style="margin-rignt:0px;" v-else>保存</button>
            </span>
        </el-dialog>
        <el-dialog
            :title="'验证码'"
            class="codes"
            :visible.sync="codeBtn"
            v-loading.body="infoload"
            size="tiny">
            <div style="color:red;margin-top:10px;font-size:12px;text-align:center;position:absolute;top:8px;left:7em;" v-if="!isSendCodeBtn">
                <span >验证码已发送到老板手机号</span>
            </div>
            <div  style="color:red;font-size:12px;text-align:center;">
                <span>验证成功后5分钟内有效，请及时操作</span>
            </div>
            <div class="inners">
                <input type="text" placeholder="请输入验证码" v-model="code">
                <span class="sendcode" @click="getCode" v-if="isSendCodeBtn">获取验证码</span>
                <span class="times" v-if="!isSendCodeBtn" v-text="isSendCodeTimer+'s'"></span>
            </div>
            <span slot="footer" class="dialog-footer">
                <button type="button" @click="codeBtn=false" class="cancel" id="employeeCodeSave">取消</button>
                <button type="button" @click="codeFn" class="save" id="employeeCodeSave">提交</button>
            </span>
        </el-dialog>
        <img-crop v-if="showCrop" :oldImg="oldImgBase64" :curCropW="curCropW" :curCropH="curCropH" :curStoreId="curStoreId" @closeImgCrop="showCrop=false" @getCropImgBase="getCropImgBase"></img-crop>
    </div>
</template>

<script type="text/javascript">
    import imgCrop from '@/components/imgCrop/imgCrop.vue';
    import {API_BASE_URL} from "./../../../urlConfig/index";
    export default{
        components: {imgCrop},
        props: ['curStoreId','pageSize','storeData'],
    	data () {
    		return {
                leaseProductEnabled:false,
                deliveryEnabled:false,
                isSendCodeBtn:true,
                isSendCodeTimer:59,
                payUrlBtn:false,
                code:'',
                codeBtn:false,
                disclaimer:true,
                shopmanBtn:false,
                shopman:{
                    wechatPayUrl:'',// 微信二维码
                    aliPayUrl:'',// 支付宝二维码
                    verifyCode:'',// 验证码
                },
                shopmanCtrol:true,
                addEmplVisible: false,
                employeeList: [], // 员工列表
                jobsList: [], // 岗位列表
                newEmployee: {
                    id: '', // 员工id
                    name: '', // 员工姓名
                    code: '', // 编号
                    mobile: '', // 手机
                    storeId: this.curStoreId, // 商铺id
                    groupId: '', // 岗位id
                    verifyCode: '', // 验证码
                    wechatPayUrl: '', // 微信二维码
                    aliPayUrl: '', // 支付宝二维码
                    target: '', // 销售目标
                    photo:'',
                    sendCouponEnabled:0,
                    deliveryEnabled:false,
                    leaseEnabled:false,
                },
                addEmployeeApiBtn: true, // 控制新增员工接口
                isEdter:false,//是否是修改员工


                coverImgMaxSize: 5*1024*1024, // 图片最大字节数
                oldImgBase64: '', // 原图base64
                showCrop: false, // 控制图片裁剪显示隐藏
                curCropW: 600, // 裁剪宽度
                curCropH: 600, // 裁剪高度
                infoload: false, // loading
                urlType:'',//收款码类型

                employeeStatus:true,//员工状态
                searchVal:"",
                oriEmps:[]
    		}
    	},
        watch:{
            employeeStatus(val){
                this.getEmployees();
            },
            searchVal(val,oldVal){
                console.log("oldVal",oldVal);
                console.log("val",val);
                let flag = false;
                if(val.length - oldVal.length < 0){
                    flag = true;
                }
                if(val){
                    setTimeout(()=>{
                        let employeeList = JSON.parse(JSON.stringify(this.employeeList));
                        if(flag){
                            employeeList = JSON.parse(JSON.stringify(this.oriEmps));
                        }
                        let newList = employeeList.filter(it=>{
                            if((it.name&&it.name.indexOf(val)!=-1)||(it.mobile&&it.mobile.indexOf(val)!=-1)){
                                return it;
                            }
                        });

                        console.log(newList)
                        
                        let number = this.pageSize - newList.length;
                        if ( number > 0 ) {
                            for (let i = 0; i < number; i++) {
                                newList.push({
                                    id: '', // 员工id
                                    name: '', // 员工姓名
                                    code: '', // 编号
                                    mobile: '', // 手机
                                    groupName: '' // 岗位id
                                });
                            }
                        }
                        this.employeeList = newList;
                    },100)
                }else{
                    // 获取员工列表
                    this.getEmployees();
                    // 获取岗位列表
                    this.getJobsList();
                }
            }
        },
        methods: {
            // 删除图片
            delImg(type){
                if(type==='wechat'){
                    // console.log('微信');
                    this.newEmployee.wechatPayUrl = '';
                }else if(type === 'ali'){
                    // console.log('ali');
                    this.newEmployee.aliPayUrl = '';
                }else if(type === 'bossWechat'){
                    // console.log('bossWechat');
                    this.shopman.wechatPayUrl = '';// 微信二维码
                }else if(type === 'bossAli'){
                    this.shopman.aliPayUrl = '';// 
                    // console.log('bossAli');
                }
            },
            //获取店主短信验证码
            getCode(){
                this.$http.post(this.curStoreId+'/verify-code').then((res)=>{
                    this.$message({
                        message: '发送成功！',
                        customClass: 'success'
                    })
                    this.isSendCodeBtn = false;
                    let timer;
                    timer = setInterval(()=>{
                        this.isSendCodeTimer--;
                        if(this.isSendCodeTimer==0){
                            clearInterval(timer);
                            this.isSendCodeTimer =59;
                            this.isSendCodeBtn = true;
                        }
                    },1000)
                })
            },
            codeFn(){
                this.code = this.code.replace(/(^\s*)|(\s*$)/g, "");
                if(!/^\d{4}$/.test(this.code)){
                    this.$message({
                        message: '验证码格式有误！',
                        customClass: 'error'
                    })
                    return;
                }
                this.$http.post(this.curStoreId+'/validate-code',this.code).then((res)=>{
                    localStorage.setItem('verifyCode', this.code);
                    this.code = '';
                    this.codeBtn = false;
                    this.$message({
                        message: '操作成功！',
                        customClass: 'success'
                    })
                })
            },
            //店主上传二维码
            shopmanShow(){
                this.$http.get(this.curStoreId+'/shopman').then((res)=>{
                    if(res.data.wechatPayUrl){
                        this.shopman.wechatPayUrl=res.data.wechatPayUrl;
                    }else{
                        this.shopman.wechatPayUrl='';
                    }
                    if(res.data.aliPayUrl){
                        this.shopman.aliPayUrl=res.data.aliPayUrl;
                    }else{
                         this.shopman.aliPayUrl='';
                    }
                    this.disclaimer = true;
                    this.shopmanBtn=true;
                })
            },
            //店主添加收款码
            shopmanFn(){
                if(!this.shopman.wechatPayUrl&&!this.shopman.aliPayUrl){
                     this.$message({
                        message: '请上传收款二维码',
                        customClass: 'error'
                    })
                    return;
                }
                if ( !this.shopmanCtrol ) {
                    return;
                }
                this.shopmanCtrol = false;
                this.shopman.verifyCode=localStorage.getItem('verifyCode', this.code);
                let body=this.shopman
                this.$http.post(this.curStoreId+'/shopman',body).then((res)=>{
                    this.shopman = {
                        wechatPayUrl:'',// 微信二维码
                        aliPayUrl:''// 支付宝二维码
                    };
                    this.shopmanCtrol = true;
                    this.shopmanBtn = false;
                }).catch((err)=>{
                    this.shopmanCtrol = true;
                })
            },
            // 新增，更新员工
            addEmployee: function () {
                if(!this.newEmployee.code){
                    this.$message({
                        message: '请输入员工工号',
                        customClass: 'error'
                    })
                    return;
                }
                if(!/^[a-zA-Z0-9]+$/.test(this.newEmployee.code)){
                    this.$message({
                        message: '工号仅允许字母和数字',
                        customClass: 'error'
                    })
                    return;
                }
                if(!this.newEmployee.name){
                    this.$message({
                        message: '请输入员工姓名',
                        customClass: 'error'
                    })
                    return;
                }
                if(!this.newEmployee.mobile){
                    this.$message({
                        message: '请输入员工电话',
                        customClass: 'error'
                    })
                    return;
                }

                // 手机号正则
                if(!(/^1[3|4|5|6|7|8|9][0-9]{9}$/.test(this.newEmployee.mobile))){
                    this.$message({
                        message: '请正确输入员工电话',
                        customClass: 'error'
                    })
                    return;
                }
                // 

                if(!this.newEmployee.groupId){
                    this.$message({
                        message: '请选择岗位',
                        customClass: 'error'
                    })
                    return;
                }
                this.newEmployee.target = this.newEmployee.target.replace(/\s+/g, "");
                if( this.newEmployee.target && !/^[0-9]*[1-9][0-9]*$/.test(this.newEmployee.target) ){
                    this.$message({
                        message: '员工业绩请输入正整数',
                        customClass: 'error'
                    })
                    return;
                }
                if ( this.newEmployee.target > 200000 ) {
                    this.$message({
                        message: '员工业绩线不能超过二十万',
                        customClass: 'error'
                    })
                    return;
                }
                if ( !this.newEmployee.id ) {
                    this.newEmployee.id = this.$uuid.create(1).hex;
                }
                if ( !this.addEmployeeApiBtn ) {
                    return;
                }
                this.newEmployee.verifyCode=localStorage.getItem('verifyCode', this.code);
                this.addEmployeeApiBtn = false;
                this.$http.put('/employees', this.newEmployee).then((res)=>{
                    this.addEmplVisible = false;
                    this.addEmployeeApiBtn = true;
                    this.$message({
                        message: '操作成功！',
                        customClass: 'success'
                    })
                    this.getEmployees();
                }).catch((err)=>{
                    this.addEmployeeApiBtn = true;
                })
            },
            // 获取员工列表
            getEmployees: function () {
                let isEnabled = (this.employeeStatus==true?true:false)
                this.$http.get('/employees?storeId='+this.curStoreId+'&enabled='+isEnabled).then((res)=>{
                    let body = res.data;
                    // if ( body && body[0] ) {
                        this.employeeList = body;
                    // }
                    this.oriEmps = body;
                    let number = this.pageSize - this.employeeList.length;
                    if ( number > 0 ) {
                        for (let i = 0; i < number; i++) {
                            this.employeeList.push({
                                id: '', // 员工id
                                name: '', // 员工姓名
                                code: '', // 编号
                                mobile: '', // 手机
                                groupName: '' // 岗位id
                            });
                        }
                    }
                }).catch((err)=>{

                })
            },
            // 获得当前员工信息
            getCurEmployee: function ( item ) {
                this.newEmployee = {
                    id: item.id, // 员工id
                    name: item.name, // 员工姓名
                    code: item.code, // 编号
                    mobile: item.mobile, // 手机
                    storeId: this.curStoreId, // 商铺id
                    groupId: item.groupId, // 岗位id
                    wechatPayUrl: item.wechatPayUrl, // 微信二维码
                    aliPayUrl: item.aliPayUrl, // 支付宝二维码
                    target: item.target<=0?'':(item.target+''), // 销售目标
                    photo:item.photo?item.photo:"https://images.huoxingy.com/%E9%BB%98%E8%AE%A4-%E5%BA%97%E5%91%98%E5%AE%9D.png",
                    sendCouponEnabled:item.sendCouponEnabled?1:0,
                    deliveryEnabled:item.deliveryEnabled,
                    leaseEnabled:item.leaseEnabled
                };
                // if(item.aliPayUrl||item.wechatPayUrl){
                //     this.payUrlBtn = true;
                // }
                this.disclaimer = true;
                this.addEmplVisible = true;
                this.isEdter = true;
            },
            // 启用 禁用员工
            enabledEmployee(item){
                this.$http.post('/employees?id='+item.id+'&status='+!item.enabled,{}).then((res)=>{
                    this.getEmployees();
                })
            },
            // 获取岗位列表
            getJobsList: function () {
                this.$http.get('/employee-groups?storeId='+this.curStoreId).then((res)=>{
                    this.jobsList = res.data;
                }).catch((err)=>{

                })
            },
            // 清除信息
            clear: function () {
                this.newEmployee = {
                    id: '', // 员工id
                    name: '', // 员工姓名
                    code: '', // 编号
                    mobile: '', // 手机
                    storeId: this.curStoreId, // 商铺id
                    groupId: '', // 岗位id
                    wechatPayUrl: '', // 微信二维码
                    aliPayUrl: '', // 支付宝二维码
                    target: '',
                    photo:'',
                    sendCouponEnabled:0,
                    deliveryEnabled:false,
                    leaseEnabled:false,
                }
                this.addEmplVisible = true;
                this.isEdter =  false;
            },
            coverImg: function ( e ,type) {
                this.urlType = type
                let reader = new FileReader();
                let that = this;
                let fileObj = e.target.files[0];

                if( e.target.files.length == 0 ) {
                    return false;
                }

                // 判断图片大小
                if( fileObj.size > this.coverImgMaxSize ) {
                    this.errorMsg = '上传图片的大小不能超过5MB';
                    this.openErrorTip = true;
                    this.$message({
                        message: '上传图片的大小不能超过5MB',
                        customClass: 'error'
                    })
                    return false;
                }

                reader.onload = (function (file) {
                    return function (e) {
                        let that2 = this; // 缓存当前this
                        let img = new Image();
                        img.src= this.result;
                        img.onload=function(){
                            let imgBase64 = that2.result; //获得图片的base64的数据

                            // 判断是否是移动端设备
                            let sUserAgent = navigator.userAgent.toLowerCase();
                            let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
                            let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
                            let bIsMidp = sUserAgent.match(/midp/i) == "midp";
                            let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
                            let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
                            let bIsAndroid = sUserAgent.match(/android/i) == "android";
                            let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
                            let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
                            if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
                                that.mobileUploadImg(imgBase64);
                            } else {
                                that.oldImgBase64 = imgBase64;
                                that.showCrop = true;
                            }
                        };
                        $('.pcImgFile').val('');
                        $('.mobileImgFile').val('');
                    };
                })(e.target.files[0]);
                reader.readAsDataURL(e.target.files[0]);
            },
            // 移动端上传图片
            mobileUploadImg: function (imgBase64) {
                this.infoload = true;
                this.$http.post(API_BASE_URL+'v1/image/json/upload?storeId='+this.curStoreId, {file: imgBase64}).then((res)=>{
                    if(this.urlType=='wechatPayUrl'){
                        this.newEmployee.wechatPayUrl =  res.data.path;
                    }else if(this.urlType=='aliPayUrl'){
                        this.newEmployee.aliPayUrl =  res.data.path;
                    }else if(this.urlType=='shopmanWechatPayUrl'){
                        this.shopman.wechatPayUrl =  res.data.path;
                    }else if(this.urlType=='shopmanAliPayUrl'){
                        this.shopman.aliPayUrl =  res.data.path;
                    };
                    this.infoload = false;
                }).catch(()=>{
                    this.infoload = false;
                });
            },
            // 获得裁剪后图片base64
            getCropImgBase: function ( imgUrl )　{
                if(this.urlType=='wechatPayUrl'){
                    this.newEmployee.wechatPayUrl = imgUrl;
                }else if(this.urlType=='aliPayUrl'){
                    this.newEmployee.aliPayUrl = imgUrl;
                }else if(this.urlType=='shopmanWechatPayUrl'){
                    this.shopman.wechatPayUrl = imgUrl;
                }else if(this.urlType=='shopmanAliPayUrl'){
                    this.shopman.aliPayUrl = imgUrl;
                }else if(this.urlType == "avatar"){
                    this.newEmployee.photo = imgUrl;
                };
            }
        },
        created: function () {
            for (let i = 0; i < this.pageSize; i++) {
                this.employeeList.push({
                    id: '', // 员工id
                    name: '', // 员工姓名
                    code: '', // 编号
                    mobile: '', // 手机
                    groupName: '' // 岗位id
                })
            }
            if(this.storeData&&this.storeData.payMode == 'CASHIER'){
               this.payUrlBtn = true; 
            }else{
                this.$http.get('/stores/'+this.curStoreId).then((res)=>{
                    if( res.data.payMode == 'CASHIER'){
                        this.payUrlBtn = true;
                    }
                });
            }
            // // this.payUrlBtn = true;
            // // 获取员工列表
            // this.getEmployees();
            // // 获取岗位列表
            // this.getJobsList();
        },
        activated(){
            console.log("kkk")
            // 获取员工列表
            this.getEmployees();
            // 获取岗位列表
            this.getJobsList();
            // 
            this.$http.get('/stores/'+this.curStoreId).then((res)=>{
                this.deliveryEnabled = res.data.deliveryEnabled;
                try {
                    this.leaseProductEnabled = res.data.leaseProductEnabled;
                } catch (error) {
                    
                }
            })
        },
        mounted: function () {
            // 改变关闭样式
            $(document).ready(()=>{
                $('.el-dialog__headerbtn i').attr('class', 'el-dialog__close iconfont icon-guanbi');
            });
        }
    }
</script>
<style lang="scss">
    @import '../../../../static/css/common.scss';
    @import '../../tableTemplate/tableTem.scss';
    @import '../../tableTemplate/el-dialog.scss';
	@import "employee";
</style>



// WEBPACK FOOTER //
// employee.vue?30ddf7dd